import Icon from '../components/Icon.vue'

Icon.register({
  tooth: {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M444 96.3c10.1 41.6 0.4 80.8-21.5 110.4-23.4 31.6-32.7 68.7-36.3 107.4-4.4 47.2-10.3 94.2-20.9 140.3l-7.8 34c-3.2 13.9-15.5 23.7-29.7 23.7-14 0-26.2-9.5-29.5-23.2l-34.5-138.4c-4.6-18.3-21-31.2-39.8-31.2-18.8 0-35.2 12.8-39.8 31.2l-34.5 138.4c-3.4 13.6-15.6 23.2-29.5 23.2-14.2 0-26.5-9.8-29.7-23.7l-7.8-34c-10.6-46.2-16.5-93.2-20.9-140.3-3.6-38.7-12.9-75.8-36.3-107.4-21.9-29.6-31.6-68.8-21.5-110.4 11-45.2 47.1-82 92-93.7 23.4-6.1 46.1-0.5 66.8 10.3l100.5 64.6c7.8 5.1 17.7 2.2 22.1-4.8 4.8-7.4 2.6-17.3-4.8-22.1l-28.3-18.2c3.5-1.8 7.3-3.1 10.5-5.5 26.1-19.2 57-32.7 89.1-24.3 44.9 11.7 81 48.5 92 93.7z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/tooth.js
// module id = 2019
// module chunks = 0